
























































































import { Component, Vue, Emit, Watch, Prop, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyNumber } from '@/utils/common'

@Component

export default class ComponentBackofficeProcedimentoAutorizarQuantidade extends Vue {
  $refs!: {
    pendenciaAutorizar: any,
    autorizacaoFinalizar: any,
  }

  headers: any[] = [
    { text: 'Procedimento', class: 'table-headers', align: 'left', sortable: false, value: 'descricao' },
    { text: 'Procedimento Convênio', class: 'table-headers', align: 'center', sortable: false, value: 'procedimentoConvenio' },
    { text: 'Qtde. solicitada', class: 'table-headers', align: 'center', sortable: false, value: 'quantidade' },
    { text: 'Qtde. autorizada', class: 'table-headers', align: 'center', sortable: false, value: 'quantidadeAutorizada' },
  ]

  quantidadeRules: any = {
    valid: true,
    quantidade: [v => (v !== null && v !== '') || 'Campo obrigatório.'],
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getProcedimentosInternacao() {
    return this.getBackofficeGlobalStore.solicitacao.procedimentosInternacao
  }

  isValid() {
    let isValidated: boolean = true

    if (this.getProcedimentosInternacao.length > 0) {
      this.getProcedimentosInternacao.map((p, index) => {
        if (!this.$refs[`formProcedimentosInternacaoQuantidade${index}`].validate()) {
          isValidated = false
        }
        return p
      })
    }

    return isValidated
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }
}
